module.exports = __webpack_public_path__ + "img/mhh1.59bf1e24.jpg";